import { breakpoint, debounce } from '../../util/helpers';
import { setElementInert, setParentInert } from '../../util/a11y/handle-inert';
import strings from '../../lang/strings.json';

export default {
  accordionItemHeights: {},
  init() {
    const $module = document.querySelector('.ms-faq-module');

    this.currentLang = document.querySelector('html').lang;
    this.lastBreakpoint = breakpoint();

    setTimeout(() => {
      this.adjustFilterWrapperHeight();
    }, 300);

    const onResize = debounce(() => {
      this.initializeAccordionListHeight($module);

      if (breakpoint() !== this.lastBreakpoint) {
        this.lastBreakpoint = breakpoint();

        this.adjustFilterWrapperHeight();
      }
    }, 300);

    window.addEventListener('resize', onResize);

    this.initializeAccordionListHeight($module);
    this.startListener($module);
  },
  adjustFilterWrapperHeight() {
    const filterWrapper = document.querySelector('.ms-faq-module__filter-wrapper');
    filterWrapper.style.height = '';

    if (this.lastBreakpoint !== 'mobile') {
      const currentActiveTab = document.querySelector('.ms-faq-module__tab-item.active');
      const filterContainer = currentActiveTab.querySelector('.ms-faq-module__button-filter-container');

      if (filterContainer) {
        filterWrapper.style.height = `${filterWrapper.offsetHeight + filterContainer.offsetHeight}px`;
      }
    }
  },
  startListener($module) {
    const body = document.body;
    const main = body.querySelector('main');
    const wrap = body.querySelector('.wrap');
    const dropdownContainer = $module.querySelector('.ms-faq-module__dropdown-container');
    const dropdownToggle = document.getElementById('faq-dropdown-button');
    const dropdownList = document.getElementById('faq-module-dropdown');
    const dropdownFilters = $module.querySelectorAll('.ms-faq-module__dropdown-option');
    const tabListContainer = $module.querySelector('.ms-faq-module__tab-list');
    const tabFilters = Array.from($module.querySelectorAll('.ms-faq-module__tab-button'));
    const buttonFiltersContainer = $module.querySelector('.ms-faq-module__button-filter-container');
    const buttonFilters = $module.querySelectorAll('.ms-faq-module__button-filter');
    const accordionWrapper = $module.querySelector('.ms-faq-module__accordions-wrapper');
    const accordionList = $module.querySelector('.ms-faq-module__accordion-list');
    const accordionToggles = $module.querySelectorAll('.ms-faq-module__accordion-item-toggle');
    const accordionItems = $module.querySelectorAll('.ms-faq-module__accordion-item');
    const thumbButtons = $module.querySelectorAll('.ms-faq-module__accordion-item-thumbs');
    const allySkipButton = $module.querySelector('.ms-faq-module__sr-skip-button');
    const tabContainer = $module.querySelector('.ms-faq-module__tab-container');
    const underline = $module.querySelector('.ms-faq-module__tab-container__underline');

    let allySkipButtonClone = null;

    const parents = [body, main];
    const exceptions = [wrap, $module];

    // Setup click events for filter elements.
    const filterItems = ({ dataset }) => {
      const { categoryIndex = '0', subCategoryIndex = null } = dataset;
      let oddEvenCounter = 1;

      accordionItems.forEach((accordionItem, index) => {
        const wrapper = accordionItem.querySelector('.ms-faq-module__accordion-item-wrapper');
        wrapper.style.transition = 'none';
        const { parentCategoryIndex, parentSubCategoryIndex } = accordionItem.dataset;
        let isAccordionVisible = categoryIndex === parentCategoryIndex;

        if (subCategoryIndex) {
          isAccordionVisible = categoryIndex === parentCategoryIndex && subCategoryIndex === parentSubCategoryIndex;
        }

        if (isAccordionVisible) {
          accordionItem.classList.remove('hidden');

          this.initializeAccordionListHeight($module);
          // Set accordion variation by odd/even class.
          accordionItem.classList.remove('odd');
          accordionItem.classList.remove('even');
          accordionItem.classList.add(oddEvenCounter % 2 === 0 ? 'even' : 'odd');

          if (oddEvenCounter === 1 || accordionItem.classList.contains('is-default')) {
            const childToggleButton = accordionItem.querySelector('.ms-faq-module__accordion-item-toggle');

            toggleAccordionExpand(accordionItem, childToggleButton, wrapper, index, true);
          }

          oddEvenCounter++;
        }
        else {
          accordionItem.classList.add('hidden');
          accordionItem.classList.remove('odd');
          accordionItem.classList.remove('even');
        }
        // Remove current aria-label attribute.
        accordionItem.removeAttribute('aria-label');
      });

      accordionItems.forEach((accordionItem) => {
        const wrapper = accordionItem.querySelector('.ms-faq-module__accordion-item-wrapper');
        wrapper.style.transition = '0.3s height';
      })

      allyAlertResult();
    };

    const allyAlertResult = () => {
      const allyAlertContainer = $module.querySelector('.ms-faq-module__sr-alert');
      const visibleAccordions = Array.from(accordionItems).filter(accordionItem => !accordionItem.classList.contains('hidden'));

      // Set dynamic aria-label of question item count.
      visibleAccordions.forEach((visibleAccordion, index) => {
        visibleAccordion.setAttribute('aria-label', `${strings[this.currentLang].item} ${index + 1} ${strings[this.currentLang].of} ${visibleAccordions.length}`);
      });

      allyAlertContainer.innerHTML = `${visibleAccordions.length} matching question${visibleAccordions.length > 1 ? 's' : ''}`;

      setTimeout(() => {
        allyAlertContainer.innerHTML = '';
      }, 2000);
    }

    const toggleDropDownVisibility = (toggleTarget) => {
      const ariaExpandAttribute = toggleTarget.getAttribute('aria-expanded');
      const lastSelected = dropdownList.querySelector('[aria-selected="true"]');

      dropdownList.classList.toggle('hidden');

      if (!ariaExpandAttribute) {
        toggleTarget.setAttribute('aria-expanded', true);

        setParentInert(true, parents, exceptions);
        setElementInert(true, accordionWrapper);
        setElementInert(true, buttonFiltersContainer);
        setElementInert(false, dropdownContainer);

        setTimeout(() => {
          dropdownList.focus();

          if (lastSelected) {
            lastSelected.focus();
          }
        }, 100);
      }
      else {
        toggleTarget.removeAttribute('aria-expanded');

        setParentInert(false, parents, exceptions);
        setElementInert(false, accordionWrapper);
        setElementInert(false, buttonFiltersContainer);

        setTimeout(() => {
          toggleTarget.focus();
        }, 100);
      }
    };

    const toggleDropdownSelected = (targetFilter) => {
      const lastSelected = dropdownList.querySelector('[aria-selected="true"]');

      if (lastSelected) {
        lastSelected.removeAttribute('aria-selected');
        dropdownList.setAttribute('aria-activedescendant', null);
      }

      dropdownToggle.innerText = targetFilter.innerText;
      targetFilter.setAttribute('aria-selected', true);
      dropdownList.setAttribute('aria-activedescendant', targetFilter.id);
    }

    const toggleButtonFilterVisibility = ({ dataset }) => {
      const mobileButtonFilters = dropdownContainer.querySelectorAll('.ms-faq-module__button-filter');
      const { categoryIndex = '0' } = dataset;

      mobileButtonFilters.forEach(mobileButtonFilter => {
        const { categoryIndex: currentCategoryIndex } = mobileButtonFilter.dataset;

        mobileButtonFilter.parentElement.classList.toggle('hidden', categoryIndex !== currentCategoryIndex);
        mobileButtonFilter.setAttribute('aria-pressed', false);
        mobileButtonFilter.classList.remove('active');
      });
    };

    const toggleAccordionExpand = (accordionTarget, buttonTarget, wrapper, index, maintainOpen = false) => {
      const currentExpandedAccordion = document.querySelector('.ms-faq-module__accordion-item--expanded');
      const ariaExpandState = buttonTarget.getAttribute('aria-expanded');

      if (currentExpandedAccordion && (currentExpandedAccordion !== accordionTarget)) {
        const currentExpandedButton = currentExpandedAccordion.querySelector('.ms-faq-module__accordion-item-toggle');

        currentExpandedAccordion.classList.remove('ms-faq-module__accordion-item--expanded');
        currentExpandedAccordion.dataset.expanded = false;
        currentExpandedButton.setAttribute('aria-expanded', false);
        currentExpandedButton.setAttribute('aria-label', strings[this.currentLang].expandItem);
        const accordionItemWrapper = currentExpandedAccordion.querySelector('.ms-faq-module__accordion-item-wrapper');
        accordionItemWrapper.style.height = '0px';
        setElementInert(true, accordionItemWrapper);
      }

      if (accordionTarget.classList.contains('is-default')) {
        accordionTarget.classList.remove('is-default');
      }

      if (maintainOpen) {
        buttonTarget.setAttribute('aria-expanded', true);
        buttonTarget.setAttribute('aria-label', strings[this.currentLang].collapseItem);
        accordionTarget.classList.add('ms-faq-module__accordion-item--expanded');
        accordionTarget.dataset.expanded = true;
        const accordionItemWrapper = accordionTarget.querySelector('.ms-faq-module__accordion-item-wrapper');
        accordionItemWrapper.style.height = `${this.accordionItemHeights[index]}px`;
        setElementInert(false, accordionItemWrapper);

        return;
      }

      buttonTarget.setAttribute('aria-expanded', ariaExpandState === 'false' ? true : false);
      buttonTarget.setAttribute('aria-label', ariaExpandState === 'false' ? strings[this.currentLang].collapseItem : strings[this.currentLang].expandItem);
      accordionTarget.classList.toggle('ms-faq-module__accordion-item--expanded');
      accordionTarget.dataset.expanded = accordionTarget.classList.contains('ms-faq-module__accordion-item--expanded');
      const accordionItemWrapper = accordionTarget.querySelector('.ms-faq-module__accordion-item-wrapper');

      const { expanded } = accordionTarget.dataset;
        if (expanded === 'true') {
          wrapper.style.height = `${this.accordionItemHeights[index]}px`;
          setElementInert(false, accordionItemWrapper);
        } else {
          wrapper.style.height = '0px';
          setElementInert(true, accordionItemWrapper);
        }
    };

    const scrollToAccordionContainer = () => {
      accordionList.setAttribute('tabindex', -1);

      window.scrollTo({
        top: accordionList.getBoundingClientRect().top,
        left: 0,
      });

      setTimeout(() => {
        accordionList.focus();
        accordionList.removeAttribute('tabindex');
      }, 1000);
    };

    const animateUnderlineTo = (tabFilter) => {
      const { left: tabLeftPosition, width: tabWidthPosition } = tabFilter.getBoundingClientRect();
      const { left: tabContainerLeftPosition } = tabContainer.getBoundingClientRect();
      underline.style.left = `${tabLeftPosition - tabContainerLeftPosition}px`;
      underline.style.width = `${tabWidthPosition}px`;
    }

    if (tabFilters.length) {
      setTimeout(() => {
        const currentActiveTab = document.querySelector('.ms-faq-module__tab-item.active');
        animateUnderlineTo(currentActiveTab);
      }, 300);
    }

    dropdownToggle.addEventListener('click', ({ target }) => {
      toggleDropDownVisibility(target);
    });

    dropdownFilters.forEach(dropdownFilter => {
      dropdownFilter.addEventListener('click', ({ target }) => {
        toggleDropDownVisibility(dropdownToggle);
        toggleDropdownSelected(target);
        toggleButtonFilterVisibility(target);
        filterItems(target);
      });
    });

    tabFilters.forEach(tabFilter => {
      tabFilter.addEventListener('click', ({ target }) => {
        const currentActiveTab = document.querySelector('.ms-faq-module__tab-item.active');

        if (currentActiveTab !== target.parentElement) {
          currentActiveTab.classList.remove('active');
          currentActiveTab.firstElementChild.setAttribute('aria-selected', false);

          target.parentElement.classList.add('active');
          target.setAttribute('aria-selected', true);
          target.after(allySkipButton);
          animateUnderlineTo(target);

          filterItems(target);

          // Reset button filter active states.
          buttonFilters.forEach(mobileButtonFilter => { mobileButtonFilter.classList.remove('active'); });

          this.adjustFilterWrapperHeight();
        }

        return;
      });

      tabFilter.addEventListener('focus', ({ target }) => {
        if (target.parentElement.classList.contains('active')) {
          allyAlertResult();
        }
      });
    });

    buttonFilters.forEach(buttonFilter => {
      buttonFilter.addEventListener('click', ({ target }) => {
        const { dataset } = target;
        const parentListContainer = buttonFilter.parentElement.parentElement;
        const currentActiveButton = parentListContainer.querySelector('.ms-faq-module__button-filter.active');

        if (allySkipButtonClone) {
          allySkipButtonClone.remove();
        }

        if (currentActiveButton && currentActiveButton !== target) {
          currentActiveButton.setAttribute('aria-pressed', false);
          currentActiveButton.classList.remove('active');
        }

        target.classList.toggle('active');
        target.setAttribute('aria-pressed', target.classList.contains('active') ? 'true' : 'false');

        if (target.classList.contains('active')) {
          filterItems(target);

          allySkipButtonClone = allySkipButton.cloneNode(true);
          allySkipButtonClone.addEventListener('click', () => { scrollToAccordionContainer() });

          target.after(allySkipButtonClone);
        }
        else {
          filterItems({
            'dataset': {
              ...dataset,
              subCategoryIndex: null,
            },
          });

          allySkipButtonClone.removeEventListener('click');
          allySkipButtonClone.remove();
        }
      });
    });

    accordionToggles.forEach((accordionToggle, index) => {
      const { parentElement: accordionItem } = accordionToggle;
      const wrapper = accordionItem.querySelector('.ms-faq-module__accordion-item-wrapper');
      const accordionWrapper = accordionItem.querySelector('.ms-faq-module__accordion-item-wrapper');
      setElementInert(true, accordionWrapper);
      accordionToggle.addEventListener('click', ({ target }) => {
        toggleAccordionExpand(target.parentElement, target, wrapper, index);
      });
    });

    accordionItems.forEach((accordionItem, index) => {
      const childToggleButton = accordionItem.querySelector('.ms-faq-module__accordion-item-toggle');
      const wrapper = accordionItem.querySelector('.ms-faq-module__accordion-item-wrapper');
      const accordionTitle = accordionItem.querySelector('h2');

      if (index === 0) {
        toggleAccordionExpand(accordionItem, childToggleButton, wrapper, index, true);
      }

      accordionTitle.addEventListener('click', () => {
        toggleAccordionExpand(accordionItem, childToggleButton, wrapper, index);
      });
    });

    const faqItems = JSON.parse(localStorage.getItem('faq_items')) || [];

    const setDataSet = ( dataset, response ) => {

      let findItem = faqItems.find(element => element.id == dataset.id);

      if( undefined === findItem ) {

        faqItems.push({ id: dataset.id, title: dataset.question, response: response });
      }else{

        let index = faqItems.indexOf(findItem);

        faqItems[index] = { id: dataset.id, title: dataset.question, response: response }
      }

      localStorage.setItem('faq_items', JSON.stringify(faqItems));
    }

    const eventThumbsButton = ( target, setData = true, response = null ) => {
      const { parentElement } = target;
      const thumbsUpResponse = parentElement.querySelector('.ms-faq-module__thumbs-response-up');
      const thumbsDownResponse = parentElement.querySelector('.ms-faq-module__thumbs-response-down');
      const activeButton = parentElement.querySelector('.ms-faq-module__accordion-item-thumbs.active');
      const isThumbsDown = target.classList.contains('ms-faq-module__accordion-item-thumbs--down');
      const onLoad = false === setData && null !== response;
      const hasDataSet = true === setData ? target.dataset && (target.dataset.id && target.dataset.question) : false;

      const hideThumbsUp = () => {
        thumbsDownResponse.classList.remove('hidden');
        thumbsUpResponse.classList.add('hidden');
      }

      const hideThumbsDown = () => {
        thumbsDownResponse.classList.add('hidden');
        thumbsUpResponse.classList.remove('hidden');
      }

      if(onLoad) {

        if( (false === response && isThumbsDown) ) {
          target.classList.add('active');
          hideThumbsUp();
        }
        else if( (true === response && !isThumbsDown) ) {
          target.classList.add('active');
          hideThumbsDown();
        }
      }
      else{
        if (activeButton) {
          activeButton.classList.remove('active');
        }
        target.classList.toggle('active');
      }

      if (isThumbsDown) {
        hasDataSet && setDataSet( target.dataset, false );
        !onLoad && hideThumbsUp();
      }
      else {
        hasDataSet && setDataSet( target.dataset, true );
        !onLoad && hideThumbsDown();
      }
    }

    thumbButtons.forEach(thumbButton => {

      if( thumbButton.dataset ) {

        let findItem = faqItems.find(element => element.id == thumbButton.dataset.id);

        undefined !== findItem && eventThumbsButton(thumbButton, false, findItem.response);
      }

      thumbButton.addEventListener('click', ({ target }) => {
        eventThumbsButton(target);
      });
    });

    // Tablet to Desktop, tab Mouse and Touch events.
    let mousedown = false;
    let startX = 0;

    tabListContainer.addEventListener('scroll', ({ target }) => {
      if (tabListContainer.scrollLeft >= target.scrollWidth - target.offsetWidth) {
        target.parentElement.classList.add('scrolled-max');
      }
      else {
        target.parentElement.classList.remove('scrolled-max');
      }

      if (target.scrollLeft < 10) {
        target.parentElement.classList.remove('scrolled');
      }
      else {
        target.parentElement.classList.add('scrolled');
      }
    });

    let currentTabFilterActive = null;

    ['mousedown', 'touchstart'].forEach(type => {
      tabListContainer.addEventListener(type, (e) => {
        const pageXValue = type === 'touchstart' && e.changedTouches.length ? e.changedTouches[0].pageX : e.pageX;

        mousedown = true;
        startX = pageXValue - tabListContainer.offsetLeft;
        currentTabFilterActive = tabFilters.find(tabFilter => tabFilter.parentElement.classList.contains('active'));

      });
    });

    ['mouseleave', 'mouseup', 'touchend'].forEach(type => {
      tabListContainer.addEventListener(type, () => { mousedown = false });
    });

    ['mousemove', 'touchmove'].forEach(type => {
      tabListContainer.addEventListener(type, (e) => {
        if(!mousedown) return;

        e.preventDefault();

        const pageXValue = type === 'touchmove' && e.changedTouches.length ? e.changedTouches[0].pageX : e.pageX;
        const x = pageXValue - tabListContainer.offsetLeft;
        const walk = x - startX;

        tabListContainer.scrollLeft += (walk * -0.03);
        if (currentTabFilterActive) animateUnderlineTo(currentTabFilterActive);
      });
    });

    allySkipButton.addEventListener('click', () => { scrollToAccordionContainer() });

    // Fire filtering immediately if there is an existing active category/sub-category.
    const currentActiveButton = document.querySelector('.ms-faq-module__button-filter.active');

    if (currentActiveButton) {
      filterItems(currentActiveButton);
    }
  },
  initializeAccordionListHeight(module) {
    const accodionList = module.querySelector('.ms-faq-module__accordion-list');
    const listItems = accodionList.querySelectorAll('li');
    listItems.forEach((item, index) => {
      const content = item.querySelector('.ms-faq-module__accordion-item-content');
      this.accordionItemHeights[index] = content.getBoundingClientRect().height;
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/faq-module.js